import { PLANNER_COLORS } from '../shared_components';

export const STAGE_META = {
  Introduction: PLANNER_COLORS.blue,
  'Record Collection': PLANNER_COLORS.blue,
  'Physical Inspection': PLANNER_COLORS.orange,
  'Report Formation and SPARTA Update': PLANNER_COLORS.yellow,
  Submission: PLANNER_COLORS.purple,
  'Feedback and Closure': PLANNER_COLORS.teal,
};

export const DRAFT_STATUS_COLOR = {
  Draft: PLANNER_COLORS.grey,
  'Ready to Launch': PLANNER_COLORS.blue,
};

export const INVOICE_STATUS_COLOR = {
  'Not Raised': PLANNER_COLORS.red,
  Raised: PLANNER_COLORS.orange,
  Paid: PLANNER_COLORS.blue,
  'Financially Closed': PLANNER_COLORS.teal,
};

/* Which `GET /plans` `status` ids back each Tracker tab (Draft covers both
   Draft and Ready to Launch — the mockup's single "Draft" tab). */
export const TAB_STATUS_QUERY = {
  draft: '1',
  ongoing: '3',
  closed: '4',
};

export const draftHd = [
  { id: 'name', label: 'Project Name', sortOption: false, width: 240, maxWidth: 240 },
  { id: 'lessor', label: 'Lessor', sortOption: false, maxWidth: 160 },
  // { id: 'itype', label: 'Inspection Type', sortOption: false },
  { id: 'assets', label: 'Assets', sortOption: false, maxWidth: 90 },
  { id: 'plannedStart', label: 'Planned Start', sortOption: false, maxWidth: 120 },
  { label: 'Status', sortOption: false, maxWidth: 120 },
  { label: 'Action(s)', sortOption: false, actionCell: true },
];

export const ongoingHd = [
  { id: 'name', label: 'Project Name', sortOption: false, width: 240, maxWidth: 240 },
  { label: 'Lessor / Lessee', sortOption: false, maxWidth: 180 },
  { label: 'Current Stage & Progress', sortOption: false, maxWidth: 180 },
  { id: 'inactivityHours', label: 'Inactivity', sortOption: false, maxWidth: 110 },
  { id: 'lead', label: 'Lead', sortOption: false, maxWidth: 140 },
  { id: 'endDate', label: 'End Date', sortOption: false, maxWidth: 120 },
  { label: 'Action(s)', sortOption: false, actionCell: true },
];

export const closedHd = [
  { id: 'name', label: 'Project Name', sortOption: false, width: 240, maxWidth: 240 },
  { id: 'lessor', label: 'Lessor', sortOption: false, maxWidth: 160 },
  { id: 'closedDate', label: 'Closed Date', sortOption: false, maxWidth: 120 },
  { id: 'durationDays', label: 'Duration', sortOption: false, maxWidth: 100 },
  { label: 'Invoice Status', sortOption: false, maxWidth: 140 },
  { label: 'Action(s)', sortOption: false, actionCell: true },
];
